/**
 * Checks whether a linked model file is viewable in the BIM viewer.
 * Reusable predicate for filtering/finding across viewpoint resolution logic.
 */
export function isViewableModel(model: API_BcfServerIfcFileInfo): boolean {
  return !!(model.id && model.fileName && !model.relinkNeeded && model.hasXktVersion);
}

/**
 * Resolves the best model to use for displaying a BCF viewpoint.
 *
 * The backend topic-file retrieval does not guarantee ordering,
 * so we must not assume issueModels[0] is the correct target.
 * Instead, we pick the first model that is actually viewable (has XKT version).
 */
export function resolveViewpointModel(issueModels: API_BcfServerIfcFileInfo[]): API_BcfServerIfcFileInfo | undefined {
  if (!issueModels || issueModels.length === 0) {
    return undefined;
  }

  return issueModels.find(isViewableModel) || issueModels[0];
}

/**
 * Checks if any model in the list has a viewable XKT version.
 */
export function hasAnyViewableModel(issueModels: API_BcfServerIfcFileInfo[]): boolean {
  if (!issueModels || issueModels.length === 0) {
    return false;
  }
  return issueModels.some(isViewableModel);
}
